import { Link } from "react-router-dom";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import Video from "./Video";

export default function Videos() {
  const { data: videos, isLoading, isError } = useGetVideosQuery() || {};

  // decide what to render
  let content = null;
  if (isLoading)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          Loading....
        </td>
      </tr>
    );
  if (!isLoading && isError)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          There was an error
        </td>
      </tr>
    );
  if (!isLoading && !isError && videos?.length === 0)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          No videos found
        </td>
      </tr>
    );
  if (!isLoading && !isError && videos?.length > 0)
    content = videos.map((video, i) => <Video key={i} video={video} />);

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <Link to={"/admin/addvideo/"}>
        <div className="w-full flex">
          <button className="btn ml-auto">Add Video</button>
        </div>
      </Link>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Video Title</th>
              <th className="table-th">Description</th>
              <th className="table-th">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">{content}</tbody>
        </table>
      </div>
    </div>
  );
}
